<template>
  <div class="content">
    <div v-if="result">
      <img :src="result.icon" class="icon">
      <div class="text">
        <div class="title">{{ result.title }}</div>
        <div class="desc" v-html="result.desc"></div>
      </div>
      <md-button v-if="result.goSignup" type="primary" class="btn-do" @click="goSignup">
        {{ result.action }}
      </md-button>
    </div>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        doItNow: 'Do It Now',
        editInformation: 'Complete your onboarding process to get {reward}.',
        editInformationNoReward: 'Complete your onboarding process.',
        editNow: 'Edit Now',
        enabledTip: 'Congratulations, your application is approved. You can start lending now.',
        reeditInformation: 'Sorry, your infomation is not approved, please check it out.',
        underVerification: 'Under verification',
        underVerificationTip: 'We are verifying your application. We will inform you the result within 24 hours.',
        unverified: 'Unverified Information',
        verifyFailed: 'Application verification failed',
      },
      id: {
        doItNow: 'Lakukan Sekarang',
        editInformation: 'Verifikasi data Anda, dapatkan {reward}.',
        editInformationNoReward: 'Verifikasi data Anda.',
        editNow: 'Edit Now',
        enabledTip: 'Informasi akun Anda telah diverifikasi. Anda dapat memulai pendanaan Anda.',
        reeditInformation: 'Sorry, your infomation is not approved, please check it out.',
        underVerification: 'Sedang diverifikasi',
        underVerificationTip: 'Aplikasi Anda sedang diverifikasi. Platform akan memberikan hasilnya dalam 24 jam.',
        unverified: 'Informasi tidak terverifikasi',
        verifyFailed: 'Verifikasi Aplikasi gagal',
      },
    },
  },
  components: {
    [Button.name]: Button,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      rewardName: '',
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    result() {
      return (
        {
          ENABLED: {
            icon: require('@/assets/image/status/icon_verify.svg'), // eslint-disable-line global-require
            title: '',
            desc: this.$t('enabledTip'),
            action: this.$t('doItNow'),
            goSignup: false,
          },
          INITIAL: {
            icon: require('@/assets/image/status/icon_fail.svg'), // eslint-disable-line global-require
            title: this.$t('unverified'),
            desc: this.rewardName ? this.$t('editInformation', { reward: this.rewardName }) : this.$t('editInformationNoReward'),
            action: this.$t('doItNow'),
            goSignup: true,
          },
          PENDING: {
            icon: require('@/assets/image/status/icon_verify.svg'), // eslint-disable-line global-require
            title: this.$t('underVerification'),
            desc: this.$t('underVerificationTip'),
            action: this.$t('doItNow'),
            goSignup: false,
          },
          REJECTED: {
            icon: require('@/assets/image/status/icon_fail.svg'), // eslint-disable-line global-require
            title: this.$t('verifyFailed'),
            desc: this.$t('editInformation', { reward: this.rewardName }),
            action: this.$t('editNow'),
            goSignup: true,
          },
        }[this.status] || null
      )
    },
  },
  async mounted() {
    if (['INITIAL', 'REJECTED'].includes(this.userInfo.status)) {
      await this.getActivityName()
    }
  },
  methods: {
    goSignup() {
      this.$router.push({ name: 'SignupAdditional' })
    },
    async getActivityName() {
      try {
        const channel = this.userInfo.channel || 'default'
        const response = await this.$http.get(`/marketing/channel?code=${channel}`)
        const data = response.data.data
        this.rewardName = data && data.eventActivityMappings ? data.eventActivityMappings.find(i => i.event === 'KYC').activityName[this.$i18n.locale] || '' : ''
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.content {
  padding: 32px 10px;
  text-align: center;
  .icon {
    width: 42px;
    height: 32px;
    margin-bottom: 8px;
  }
  .text {
    .title {
      font-size: 18px;
      padding: 8px 0;
    }
    .desc {
      color: #666;
    }
  }
  .btn-do {
    margin: 16px auto 0;
    width: auto;
  }
}
</style>
